import React from "react";

const joinClasses = (...parts) => parts.filter(Boolean).join(" ");

export const AppPage = ({ children, className = "", narrow = false, style }) => (
  <div
    className={joinClasses("app-page", narrow && "app-page--narrow", className)}
    style={style}
  >
    {children}
  </div>
);

export const AppPageHeader = ({
  eyebrow,
  title,
  description,
  actions,
  className = "",
}) => (
  <section className={joinClasses("app-page__header", className)}>
    <div className="app-page__header-copy">
      {eyebrow ? <p className="app-page__eyebrow">{eyebrow}</p> : null}
      {title ? <h2 className="app-page__title">{title}</h2> : null}
      {description ? <p className="app-page__description">{description}</p> : null}
    </div>
    {actions ? <div className="app-page__header-actions">{actions}</div> : null}
  </section>
);

export const AppToolbar = ({
  children,
  className = "",
  variant = "default",
}) => (
  <section
    className={joinClasses(
      "app-toolbar",
      variant !== "default" && `app-toolbar--${variant}`,
      className,
    )}
  >
    {children}
  </section>
);

export const AppToolbarActions = ({
  children,
  className = "",
  inline = false,
}) => (
  <div
    className={joinClasses(
      "app-toolbar__actions",
      inline && "app-toolbar__actions--inline",
      className,
    )}
  >
    {children}
  </div>
);

export const AppToolbarGrid = ({
  children,
  wide = false,
  withActions = false,
  className = "",
}) => (
  <div
    className={joinClasses(
      "app-toolbar__grid",
      wide && "app-toolbar__grid--wide",
      withActions && "app-toolbar__grid--with-actions",
      className,
    )}
  >
    {children}
  </div>
);

export const AppToolbarField = ({
  label,
  children,
  className = "",
  grow = false,
}) => (
  <div
    className={joinClasses(
      "app-toolbar__field",
      grow && "app-toolbar__field--grow",
      className,
    )}
  >
    {label ? <p className="app-toolbar__label">{label}</p> : null}
    {children}
  </div>
);

export const AppCard = ({
  title,
  description,
  actions,
  children,
  className = "",
  flush = false,
  variant = "default",
}) => (
  <section
    className={joinClasses(
      "app-card",
      variant !== "default" && `app-card--${variant}`,
      flush && "app-card--flush",
      className,
    )}
  >
    {(title || description || actions) && (
      <div className="app-card__header">
        <div className="app-card__title-group">
          {title ? <h3 className="app-card__title">{title}</h3> : null}
          {description ? <p className="app-card__description">{description}</p> : null}
        </div>
        {actions ? <div className="app-card__actions">{actions}</div> : null}
      </div>
    )}
    {children}
  </section>
);

export const AppContextBanner = ({ label, title, description, className = "" }) => (
  <section className={joinClasses("app-context-banner", className)}>
    {label ? <p className="app-context-banner__label">{label}</p> : null}
    {title ? <h3 className="app-context-banner__title">{title}</h3> : null}
    {description ? <p className="app-context-banner__description">{description}</p> : null}
  </section>
);

export const AppPill = ({ tone = "neutral", children, className = "" }) => (
  <span className={joinClasses("app-pill", `app-pill--${tone}`, className)}>
    {children}
  </span>
);
